import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mr_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const apiClient = axios.create({ baseURL: API });

apiClient.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      clearToken();
      if (window.location.pathname.startsWith("/admin")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Errore generico";
};

export const STATUS_LABELS = {
  nuovo: "Nuovo",
  in_lavorazione: "In Lavorazione",
  bonifico_inviato: "Bonifico Inviato",
  spedito: "Spedito",
  chiuso: "Chiuso",
};

export const STATUS_COLORS = {
  nuovo: "bg-[#E63946] text-white",
  in_lavorazione: "bg-amber-500 text-black",
  bonifico_inviato: "bg-sky-500 text-black",
  spedito: "bg-emerald-500 text-black",
  chiuso: "bg-zinc-600 text-white",
};

export const CORRIERI = ["GLS", "BRT", "SDA", "DHL", "Poste Italiane", "TNT", "UPS", "FedEx", "Altro"];
